<div
  class="grid gap-2"
  [ngClass]="{
    'grid-cols-1': options.length === 1,
    'grid-cols-2': options.length === 2,
    'grid-cols-3':
      options.length === 3 || options.length === 5 || options.length === 6,
    'grid-cols-4': options.length === 4,
    'md:grid-cols-5': options.length === 5,
    'xl:grid-cols-6': options.length === 6,
    'grid-cols-7': options.length === 7,
  }"
>
  @for (option of options; track option.value) {
    <div class="">
      <input
        class="peer hidden"
        type="radio"
        [name]="name"
        [id]="`${name}-${option.value}`"
        [value]="option.value"
        [disabled]="isLoading"
        [checked]="selected === option.value"
        (change)="onChange(option.value)"
      />

      <label
        class="block h-full overflow-hidden rounded-md border-1 border-grey-300 p-4 text-ellipsis transition select-none peer-checked:border-grey-500"
        [for]="`${name}-${option.value}`"
        [attr.aria-checked]="selected === option.value"
        [ngClass]="{
          'cursor-progress bg-grey-50 text-grey-400': isLoading,
          'cursor-pointer peer-checked:bg-blue-100 hover:bg-blue-50':
            !isLoading,
        }"
        [title]="option.label"
      >
        {{ option.label }}<br />
        <div
          class="flex items-center gap-2"
          [ngClass]="{
            'text-yellow':
              option.status === 'info' && option.count !== 0 && !isLoading,
            'text-blue-600':
              option.status === 'notice' && option.count !== 0 && !isLoading,
            'text-orange':
              option.status === 'warning' && option.count !== 0 && !isLoading,
            'text-green-600':
              option.status === 'success' && option.count !== 0 && !isLoading,
            'text-red-600':
              option.status === 'error' && option.count !== 0 && !isLoading,
          }"
        >
          @if (option.count !== undefined) {
            @if (isLoading) {
              <svg-icon
                class="animate-pulse"
                src="assets/icons/General/minus.svg"
              />
            } @else {
              <div class="text-lg font-bold">
                {{ option.count }}
              </div>
            }
          }
          @if (option.icon) {
            <svg-icon class="size-5" [src]="option.icon" />
          }
        </div>
      </label>
    </div>
  }
</div>
